import React, { useEffect, useState } from "react";
import Button from "../atoms/Button";
import styled, { css } from "styled-components";
import { Input } from "../atoms/Input";
import { Radio, RadioWrap } from "../atoms/Radio";
import { Checkbox, CheckboxWrap } from "../atoms/Checkbox";
import { SelectList } from "../atoms/Select";

const Guide = (props) => {
    const [radioValue, setRadioValue] = useState("2번");
    const [checkboxValue, setCheckboxValue] = useState({ "3번": true, "2번": true });
    return (
        <>
            <h1>스타일 가이드</h1>

            <GuideSection>
                <h2>텍스트</h2>

                <BoxWrap col gap>
                    <h1>H1: 해질녘 파도 속의 첨탑 (4.8rem, 48px, 800)</h1>
                    <h2>H2: 해질녘 파도 속의 첨탑 (3.6rem, 36px, 800)</h2>
                    <h3>H3: 해질녘 파도 속의 첨탑 (3.2rem, 32px, 800)</h3>
                    <h4>H4: 해질녘 파도 속의 첨탑 (2.8rem, 28px, 800)</h4>
                    <h5>H5: 해질녘 파도 속의 첨탑 (2.4rem, 24px, 800)</h5>
                    <h6>H6: 해질녘 파도 속의 첨탑 (2.0rem, 20px, 800)</h6>

                    <p>p: 해질녘 파도 속의 첨탑 (1.4rem, 14px, 500)</p>
                    <b>b: 해질녘 파도 속의 첨탑 (1.4rem, 14px, 700)</b>
                    <small>small: 해질녘 파도 속의 첨탑 (1.2rem, 12px, 300)</small>
                </BoxWrap>
            </GuideSection>

            <GuideSection>
                <h2>색상</h2>

                <div>
                    <ColorWrap type="main" />
                    <ColorWrap type="sub" />
                    <ColorWrap type="highlight" />
                    <ColorWrap type="deep" />
                    <ColorWrap type="base" />

                    <BoxWrap wrap>
                        <ColorBox type="dark">DARK</ColorBox>
                        <ColorBox type="darkgray">DARKGRAY</ColorBox>
                        <ColorBox type="gray">GRAY</ColorBox>
                        <ColorBox type="lightgray">LIGHTGRAY</ColorBox>
                        <ColorBox type="light">LIGHT</ColorBox>
                    </BoxWrap>
                    <br />

                    <BoxWrap col gap>
                        <h6>
                            해질녘 <span style={{ color: "var(--main-color)" }}>파도</span> <span style={{ color: "var(--highlight-color)" }}>속</span>의 첨탑
                        </h6>
                        <h6>
                            해질녘 <span style={{ color: "var(--deep-color)" }}>파도 속</span>의 첨탑
                        </h6>
                    </BoxWrap>
                </div>
            </GuideSection>

            <GuideSection>
                <h2>버튼</h2>

                <ButtonWrap />
                <ButtonWrap type="main" />
                <ButtonWrap type="sub" />
                <ButtonWrap type="highlight" />
                <ButtonWrap type="deep" />
                <ButtonWrap type="dark" />
            </GuideSection>

            {/* <GuideSection>
                <h2>input</h2>

                <BoxWrap gap>
                    <Input></Input>
                    <Input type="password"></Input>
                    <Input type="email" name="a1234" id="a1234" placeholder="placeholder">
                        value
                    </Input>
                    <Input type="tel" placeholder="placeholder"></Input>
                </BoxWrap>

                <h2>Radio/Checkbox</h2>

                <BoxWrap col>
                    <p>radio 선택된 값: {radioValue}</p>
                    <br />
                    <RadioWrap name="user_radio" state={[radioValue, setRadioValue]} col>
                        <Radio value={"1번"}>1번</Radio>
                        <Radio value={"2번"}>2번</Radio>
                        <Radio value={"3번"}>3번</Radio>
                    </RadioWrap>
                </BoxWrap>
                <BoxWrap col>
                    <p>
                        checkbox 값:{" "}
                        {Object.keys(checkboxValue).map((el) => {
                            return el + " : " + checkboxValue[el];
                        })}
                    </p>
                    <br />
                    <CheckboxWrap name="user_checkbox" state={[checkboxValue, setCheckboxValue]} col>
                        <Checkbox checked={checkboxValue["1번"] && true} value={"1번"}>
                            1번
                        </Checkbox>
                        <Checkbox checked={checkboxValue["2번"] && true} value={"2번"}>
                            2번
                        </Checkbox>
                        <Checkbox checked={checkboxValue["3번"] && true} value={"3번"}>
                            3번
                        </Checkbox>
                    </CheckboxWrap>
                </BoxWrap>

                <h2>SELECT</h2>

                <BoxWrap>
                    <SelectList></SelectList>
                </BoxWrap>
            </GuideSection> */}
        </>
    );
};

let GuideSection = styled.section`
    display: flex;
    flex-direction: column;
    gap: 20px;
`;

let BoxWrap = styled.div`
    display: flex;

    ${({ col, row, wrap, gap }) => {
        return css`
            ${col ? "flex-direction: column;" : ""};
            ${row ? "flex-direction: row;" : ""};
            ${wrap ? "flex-wrap: wrap;" : ""};
            ${gap ? "gap: 10px" : ""}
        `;
    }}
`;

let ColorBox = styled.div`
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 70px;
    aspect-ratio: 1/1;
    background-color: #eee;
    text-align: center;

    ${({ type }) => {
        return css`
            ${type ? `background-color: var(--${type}-color);` : ""}
            ${(type && type.indexOf("dark") > -1) || type.indexOf("deep") > -1 ? "color: #fff;" : ""}
        `;
    }}
`;

const ColorWrap = (props) => {
    let { type } = props;

    return (
        <>
            <BoxWrap wrap>
                <ColorBox type={type + "-light"}>{type.toUpperCase()}-LIGHT</ColorBox>
                <ColorBox type={type + ""}>{type.toUpperCase()}</ColorBox>
                <ColorBox type={type + "-dark"}>{type.toUpperCase()}-DARK</ColorBox>
            </BoxWrap>
        </>
    );
};

const ButtonWrap = (props) => {
    let { type } = props;

    type = type ?? "default";

    return (
        <>
            <BoxWrap gap>
                <Button type={type}>{type.toUpperCase()} 버튼</Button>

                <Button type={type} disabled>
                    {type.toUpperCase()} 버튼 disabled
                </Button>

                <Button type={type} active>
                    {type.toUpperCase()} 버튼 active
                </Button>
            </BoxWrap>
        </>
    );
};

export default Guide;
